import { Controller } from "@hotwired/stimulus"

export default class ProfileSectionTypeController extends Controller {
  static targets = ["typeSelect", "fields", "card", "hiddenInput", "previewFrame"]
  static values = { initialType: String, previewUrl: String }

  connect() {
    const type = this.initialTypeValue || "block_text"
    this.showFields(type)
    this.highlightCard(type)
    this._previewTimer = null
    this._observeFormChanges()
    // 초기 미리보기 로드
    this._schedulePreview()
  }

  disconnect() {
    if (this._observer) this._observer.disconnect()
  }

  switchType(event) {
    this.showFields(event.target.value)
  }

  selectType(event) {
    const card = event.currentTarget
    const type = card.dataset.sectionTypeValue
    if (this.hasHiddenInputTarget) {
      this.hiddenInputTarget.value = type
    }
    this.showFields(type)
    this.highlightCard(type)
    this._schedulePreview()
    this.dispatch("changed", { detail: { sectionType: type }, bubbles: true })
  }

  refreshPreview() {
    this._loadPreview()
  }

  highlightCard(type) {
    this.cardTargets.forEach(card => {
      const isActive = card.dataset.sectionTypeValue === type
      card.classList.toggle("border-indigo-500", isActive)
      card.classList.toggle("bg-indigo-50", isActive)
      card.classList.toggle("border-gray-200", !isActive)
    })
  }

  showFields(type) {
    this.fieldsTargets.forEach(el => {
      const isActive = (el.dataset.sectionType === type)
      el.classList.toggle("hidden", !isActive)
      el.querySelectorAll("input, textarea, select").forEach(input => {
        input.disabled = !isActive
      })
    })
  }

  // 폼 변경 감지 — input/change 이벤트로 디바운스 미리보기
  _observeFormChanges() {
    const form = this.element
    form.addEventListener("input", () => this._schedulePreview())
    form.addEventListener("change", () => this._schedulePreview())
  }

  _schedulePreview() {
    if (this._previewTimer) clearTimeout(this._previewTimer)
    this._previewTimer = setTimeout(() => this._loadPreview(), 600)
  }

  async _loadPreview() {
    if (!this.hasPreviewFrameTarget || !this.previewUrlValue) return

    const form = this.element
    const formData = new FormData(form)
    // 파일 입력은 제외 (미리보기에서 불필요)
    for (const [key] of [...formData.entries()]) {
      if (formData.get(key) instanceof File) formData.delete(key)
    }

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    try {
      const response = await fetch(this.previewUrlValue, {
        method: "POST",
        headers: { "X-CSRF-Token": csrfToken },
        body: formData
      })
      if (response.ok) {
        const html = await response.text()
        const iframe = this.previewFrameTarget
        iframe.srcdoc = html
        // iframe 높이 자동 조절
        iframe.onload = () => {
          try {
            const body = iframe.contentDocument?.body
            if (body) {
              const height = body.scrollHeight
              iframe.style.height = Math.max(200, height) + "px"
            }
          } catch (e) { /* cross-origin 무시 */ }
        }
      }
    } catch (e) {
      // 네트워크 에러 무시
    }
  }
}
